import cx from 'classnames'
import { useEffect } from 'react'
import { CallUser } from 'store/slices/agora'
import Avatar from 'components/Avatar'

const SendGiftUserSelect = ({
  userList,
  activeRecipient,
  onSelectActiveRecipient,
}: {
  userList: Array<CallUser>
  activeRecipient: CallUser
  onSelectActiveRecipient: Function
}) => {
  return (
    <>
      {userList.map((user) => {
        return (
          <div
            key={user.id}
            className={cx('GiftRecipientSelectionPanel__item', {
              'GiftRecipientSelectionPanel__item--active':
                user.id === activeRecipient?.id,
            })}
            onClick={() => onSelectActiveRecipient(user)}
          >
            <div
              className={cx('GiftRecipientSelectionPanel__item__avatar', {
                'GiftRecipientSelectionPanel__item__avatar--role-host':
                  user.role === 'host',
                'GiftRecipientSelectionPanel__item__avatar--role-moderator':
                  user.role === 'moderator',
              })}
            >
              <Avatar user={user} />
            </div>
            <div
              className={cx('GiftRecipientSelectionPanel__item__name', {
                'GiftRecipientSelectionPanel__item__name--active':
                  user.id === activeRecipient?.id,
              })}
            >
              {user.nickname}
            </div>
          </div>
        )
      })}
    </>
  )
}

export default SendGiftUserSelect
